import APIV5 from '~/models/api';
import templateModalWfHistory from '~/components/wf/modal/modal-wf-history.html';
import ModalWfHistoryController from '~/components/wf/modal/modal-wf-history.controller';
import { wfGetJobDescription, wfMap } from '~/scripts/services/model/workflow';

/* globals Knitiv */

export default class WfAffectListController {
	/* @ngInject */
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 * @param {import('angular').IFilterService} $filter
	 * @param {import('angular').ILocationService} $location
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {import('angular').ISCEService} $sce
	 * @param {import('angular').IScope} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('angular').ui.bootstrap.IModalService} $uibModal
	 * @param {any} Notification
	 */
	constructor(
		$injector,
		$filter,
		$location,
		$rootScope,
		$sce,
		$scope,
		$timeout,
		$translate,
		$uibModal,
		Notification,
	) {
		this.$injector = $injector;
		this.$filter = $filter;
		this.$location = $location;
		this.$rootScope = $rootScope;
		this.$sce = $sce;
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$translate = $translate;
		this.$uibModal = $uibModal;
		this.Notification = Notification;

		/** @type {any[] | undefined} */
		this.data = undefined;

		/** @type {boolean} */
		this.disabled = false;

		/** @type {?import('~/scripts/services/model/form').default} */
		this.form = null;

		/** @type {any[]} */
		this.group = [];

		/** @type {boolean} */
		this.isAdminWF = false;

		/** @type {?import('~/components/kform/kform.controller').default} */
		this.kform = null;

		/** @type {?import('@knitiv/api-client-javascript').KNode} */
		this.kid = null;

		/** @type {any[]} */
		this.modelActions = [];

		/** @type {any[]} */
		this.selected = [];

		/** @type {boolean} */
		this.showAddWorkflow = false;

		/** @type {{ open: any[], close: any[] }} */
		this.wfList = {
			open: [],
			close: [],
		};

		/** @type {any} */
		this.wfOptions = {
			eligible:      true,
			list:          'ALL',
			node:          undefined,
			required:      true,
			showAddButton: true,
		};
	}

	cancelAddWorkflow() {
		if (this.data?.length === 0) {
			this.showAddWorkflow = false;
		}
		else if (this.data) {
			this.data.pop();
			if (this.data.length === 0) {
				this.showAddWorkflow = false;
			}
		}
	}

	/**
	 * @param {any} job
	 * @returns {any}
	 */
	checkUser(job) {
		return job.allocator_to.some((/** @type {any} */ a) => a.kid === this.$rootScope.context?.profil.kid);
	}

	/**
	 * @param {any} job
	 * @returns {string}
	 */
	getJobDescription(job) {
		return wfGetJobDescription(this.$injector, job);
	}

	/**
	 * @param {string | number | Date} date
	 * @returns {Date}
	 */
	getWfDate(date) {
		return new Date(date);
	}

	async openModalHistory(job = null) {
		try {
			await this.$uibModal.open({
				template:     templateModalWfHistory,
				controller:   ModalWfHistoryController,
				controllerAs: '$ctrl',
				resolve:      {
					jobs: () => (job ? [job] : this.selected),
				},
				size:         'full-with-footer',
			}).result;
		}
		catch (error) {
			if (error !== 'cancel') {
				console.error(error);
			}
		}
	}

	async list() {
		if (this.kid !== null) {
			const wfList = await APIV5.instance.wfNodeAffectList({ node: this.kid }, { id: 'kform-tab-wf.list' });
			this.$timeout(() => {
				this.wfList.close = wfList.list_close.map((/** @type {any} */ wfo) => wfMap(wfo));
				this.wfList.open = wfList.list_open.map((/** @type {any} */ wfo) => wfMap(wfo));
			});
		}
	}

	/**
	 * @param {any} job
	 * @returns {any}
	 */
	openJob(job) {
		if (this.kform?.options.modal) {
			this.kform.options.modal.dismiss();
		}
		return this.$location.path(`/workflow/${job.kid}`);
	}

	/**
	 * @param {any} job
	 */
	async subscriptionSet(job) {
		const jobs = job ? [job] : this.selected;
		for (const job2 of jobs) {
			await APIV5.instance.wfSubscriptionSet({ objnum: job2.kid });
			this.Notification.info({
				title:   this.$translate.instant('common.info'),
				message: this.$translate.instant('workflow.successful-subscription'),
			});
		}
	}

	/**
	 * @param {any} job
	 */
	toggleSelection(job) {
		const index = this.selected.findIndex(c => c.kid === job.kid);

		if (index > -1) {
			this.selected.splice(index, 1);
		}
		else {
			this.selected.push(job);
		}
	}

	$onInit() {
		this.wfOptions.node = this.kid;
		if (this.modelActions.length > 0) {
			this.showAddWorkflow = true;
		}

		(async () => this.list())();
		this.$scope.$on('Form.submitted', () => this.list());

		this.group.push({
			id:           'open',
			panelClass:   'panel-info',
			icon:         'fa-play-circle',
			title:        this.$translate.instant('workflow.title-open'),
			showAdd:      this.showAddWorkflow && !this.disabled,
			checkBox:     true,
			subscription: true,
			history:      true,
			openWf:       true,
		}, {
			id:           'close',
			icon:         'fa-stop-circle',
			panelClass:   'panel-success',
			title:        this.$translate.instant('workflow.title-close'),
			showAdd:      false,
			checkBox:     false,
			subscription: false,
			history:      true,
			openWf:       false,
		});

		this.isAdminWF = this.$rootScope.context?.role.mode === 'ADMIN_SUPER'
			|| this.$rootScope.context?.role.sql_in.includes('K_NODE;KR_ADMIN_WF')
			|| this.$rootScope.context?.role.sql_in.includes('K_NODE;KR_ADMIN_SYS')
			|| false;
		if (!this.isAdminWF) {
			this.wfOptions.showAddButton = false;
		}
	}
}
